<template>
  <require from="framework/value_converters/hide-by-property"></require>
  <require from="controls/bs-nav-item"></require>

  <div>
    <div as-element="bs-nav-item" repeat.for="childItem of model.item.items | hideByProperty:'settings.hidden' & signal:'navigation-changed'" item.bind="childItem" link-clicked.call="model.linkClicked(childItem)"></div>
  </div>
</template>
